import { useMemo } from 'react';
import GoToPoDetails from 'src/components/GoToPoDetails';
import { GridColumn } from 'src/components/GridWrapper';
import InfoButton from 'src/sections/enter_receipt/custom_grid_cell/InfoButton';
import PoStatus from 'src/sections/enter_receipt/custom_grid_cell/PoStatus';
import OfflineSupplierCell from 'src/sections/enter_receipt/custom_grid_cell/cells/OfflineSupplierCell';

export const useInvoicePoColumns = () => {
  const invoiceColumns: GridColumn<any>[] = useMemo(
    () => [
      {
        field: 'errors',
        title: '',
        width: 40,
        component: InfoButton,
        menu: false,
      },
      {
        field: 'poNum',
        title: 'PO #',
        filter: 'text',
        dataType: 'string',
        component: GoToPoDetails,
      },
      {
        field: 'numberOfInvoices',
        title: '# Documents',
        filter: 'numeric',
        dataType: 'number',
        filterFormat: '#',
        step: 1,
        component: OfflineSupplierCell,
      },
      {
        field: 'poStatus',
        title: 'Status',
        component: PoStatus,
        filter: 'text',
        dataType: 'string',
      },
      {
        field: 'statusDate',
        title: 'Status Date',
        filter: 'date',
        format: '{0:MM/dd/yyyy}',
        dataType: 'date',
        component: OfflineSupplierCell,
      },
      {
        field: 'supplierName',
        title: 'Supplier Name',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'buyerName',
        title: 'Buyer',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'poSubject',
        title: 'Subject',
        filter: 'text',
        dataType: 'string',
        component: OfflineSupplierCell,
      },
      {
        field: 'poTotal',
        title: 'PO Total',
        filter: 'numeric',
        format: '{0:c}',
        dataType: 'dollar',
        filterFormat: 'c',
        component: OfflineSupplierCell,
      },
    ],
    []
  );
  return invoiceColumns;
};

export default useInvoicePoColumns;
